<template>
  <ValidationProvider
    tag="tr"
    :vid="vid"
    :mode="veeMode"
    :rules="veeRules"
    v-slot="{ classes, valid, invalid, errors }"
  >
    <th scope="row" width="25%">{{ label }}</th>
    <td width="10%">
      <span class="bg-red" v-show="isRequired">必須</span>
    </td>
    <td class="form-inline no-margin-top">
      <slot name="beforeInput" :classes="classes" :invalid="invalid" :errors="errors" :valid="valid" />
      <v-select
        v-bind="$attrs"
        v-model="selectedValue"
        :class="buildClasses(classes)"
        :placeholder="placeholder"
        :clearable="false"
        :options="options"
        :reduce="(option) => option[optionValue]"
        :label="optionLabel"
        :message="message"
      />
      <slot v-if="message"
        ><div class="message">{{ message }}</div></slot
      >
      <slot name="afterInput" :classes="classes" :invalid="invalid" :errors="errors" :valid="valid" />
      <slot name="feedback" :classes="classes" :invalid="invalid" :errors="errors" :valid="valid">
        <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
      </slot>
    </td>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';

export default {
  inheritAttrs: false,
  props: {
    vid: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [], // Ex: [{value: 1, text: 'abc'}, {value: 2, text: 'bcd'}]
    },
    optionLabel: {
      type: String,
      default: 'text',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    inputClass: {
      type: String,
      default: 'col-lg-6',
    },
    extraRules: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    baseRule: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  components: {
    ValidationProvider,
  },
  methods: {
    buildClasses(veeClasses) {
      let veeClassesActive = Object.keys(veeClasses).filter((key) => veeClasses[key]);

      // Only add class is-valid or is-invalid for no required field when input has value
      veeClassesActive = this.isRequired || (this.value && veeClasses.validated) ? veeClassesActive : {};

      return ['form-control', 'no-padding', this.inputClass].concat(Object.values(veeClassesActive)).join(' ');
    },
  },
  computed: {
    isRequired() {
      return this.extraRules.includes('required');
    },
    rules() {
      return this.extraRules.split('|');
    },
    veeRules() {
      let rules = [this.baseRule].concat(this.rules);

      // re-order rule required to first
      rules = uniq(
        sortBy(rules, [
          function (o) {
            return o.indexOf('required') ? 1 : 0;
          },
        ])
      );

      return rules.join('|');
    },
    veeMode() {
      return 'aggressive';
    },
    selectedValue: {
      get() {
        this.$logger.debug('selectedValue#get', this.value);
        return this.value;
      },
      set(val) {
        this.$logger.debug('selectedValue#set', val);
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.message {
  color: red;
  margin-top: 5px;
  font-size: 12px;
}
</style>
